import {inject, Injectable} from "@angular/core";
import {CanDeactivate, GuardResult, MaybeAsync, NavigationEnd, Router} from "@angular/router";
import {filter, take} from "rxjs";
import {WidgetConstructorStore} from "@widgets/widget-constructor";
import {WidgetConstructorPageComponent} from "../ui/widget-constructor-page/widget-constructor-page.component";

@Injectable({providedIn: "root"})
export class CanConstructorDeactivate implements CanDeactivate<WidgetConstructorPageComponent> {
    store = inject(WidgetConstructorStore);
    router = inject(Router);

    canDeactivate(): MaybeAsync<GuardResult> {
        const sub = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd),
                take(1)
            ).subscribe(() => {
                this.store.reset();
                sub.unsubscribe();
            });

        return true;
    }
}
